import React, { useState } from "react";
import { UserPlus, X } from "lucide-react";

const BulkAssignBar = ({ selectedCount, assignOptions, onAssign, onClear }) => {
    const [assignTo, setAssignTo] = useState("");

    if (selectedCount === 0) return null;

    const handleAssign = () => {
        if (!assignTo) return;
        onAssign(assignTo);
        setAssignTo("");
    };

    return (
        <div className="sticky bottom-2 z-30 flex flex-wrap items-center gap-2 p-3 rounded-xl border border-primary/40 bg-primary-soft shadow-lg">
            <span className="text-sm font-semibold text-primary">
                {selectedCount} selected
            </span>
            <select
                value={assignTo}
                onChange={(e) => setAssignTo(e.target.value)}
                className="flex-1 min-w-[140px] rounded-lg border border-line bg-surface px-3 py-2 text-sm text-ink min-h-[40px]"
            >
                <option value="">Assign to…</option>
                {assignOptions.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                        {opt.label}
                    </option>
                ))}
            </select>
            <button
                type="button"
                onClick={handleAssign}
                disabled={!assignTo}
                className="inline-flex items-center gap-1.5 px-4 py-2 rounded-lg bg-primary text-primary-contrast text-sm font-semibold disabled:opacity-40 min-h-[40px]"
            >
                <UserPlus size={16} />
                Assign
            </button>
            <button
                type="button"
                onClick={onClear}
                className="p-2 rounded-lg hover:bg-surface-2 text-ink-muted min-h-[40px] min-w-[40px] flex items-center justify-center"
                title="Clear selection"
            >
                <X size={18} />
            </button>
        </div>
    );
};

export default BulkAssignBar;
